module.exports = __webpack_public_path__ + "toBride2-we-b-b.e58d7d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-b-b.jpg
// module id = p2Ve
// module chunks = 0